import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "/mnt/f/Users/sGerli/Development/rebble/rebble-store/build/sprite_module.conf.js";
var symbol = new SpriteSymbol({
  "id": "iconDownload",
  "use": "iconDownload-usage",
  "viewBox": "0 0 23 23",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23 23\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"iconDownload\">\r\n  <defs>\r\n    <rect id=\"iconDownload_a\" width=\"15\" height=\"16\" x=\"3\" />\r\n  </defs>\r\n  <g fill-rule=\"evenodd\" transform=\"translate(1)\">\r\n    <rect width=\"21\" height=\"8\" y=\"14\" stroke=\"currentColor\" stroke-width=\"2\" />\r\n    <mask id=\"iconDownload_b\" fill=\"white\">\r\n      <use xlink:href=\"#iconDownload_a\" />\r\n    </mask>\r\n    <polygon stroke=\"currentColor\" stroke-width=\"2\" points=\"8.727 1 12.273 1 12.273 9 17 9 10.5 16 4 9 8.727 9\" mask=\"url(#iconDownload_b)\" />\r\n    <rect width=\"2\" height=\"2\" x=\"16\" y=\"17\" stroke=\"currentColor\" stroke-width=\"2\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/Download.svg
// module id = /zJ5
// module chunks = 1